/* 演示计数器核心实现。参数在 snippets/demo-counter.liquid；不读取或修改真实订单。
 * 当前页面独立计数：可见时每隔 intervalMs 加 1，刷新后重置；不保存到浏览器或服务器。
 */
(() => {
  const counters = new Map();
  function initialize(root = document) {
    const elements = [...root.querySelectorAll('[data-demo-counter]')];
    if (root.matches?.('[data-demo-counter]')) elements.unshift(root);
    elements.forEach(element => {
      if (counters.has(element)) return;
      const value = element.querySelector('[data-demo-value]');
      if (!value) return;
      const start = Number(element.dataset.start);
      const interval = Number(element.dataset.intervalMs);
      let count = Number.isSafeInteger(start) && start >= 0 ? start : 0;
      const intervalMs = Number.isSafeInteger(interval) && interval >= 1000 && interval <= 2147483647 ? interval : 10000;
      value.textContent = String(count);
      // 定时加 1 的位置。隐藏页面暂停，不补算离开期间的次数。
      const timer = setInterval(() => {
        if (!element.isConnected) { clearInterval(timer); counters.delete(element); return; }
        if (document.hidden || count >= Number.MAX_SAFE_INTEGER) return;
        value.textContent = String(++count);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && value.animate) {
          value.animate([{ transform: 'translateY(.25em)', opacity: .35 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 250 });
        }
      }, intervalMs);
      counters.set(element, timer);
    });
  }
  initialize();
  // Shopify 主题编辑器重新加载区块时初始化，避免重复注册计时器。
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    counters.forEach((timer, element) => {
      if (event.target.contains(element)) { clearInterval(timer); counters.delete(element); }
    });
  });
})();
